import { useLocation } from 'react-router-dom';
import { useFracas } from '../contexts/FracasContext';
import { useEightD } from '../contexts/EightDContext';
import { useLabSample } from '../contexts/LabSampleContext';

export interface AssistantContextData {
    type: string;
    summary: string;
    details: string;
}

export const useAssistantContext = () => {
    const location = useLocation();
    const { incidents } = useFracas();
    const { reports } = useEightD();
    const { samples } = useLabSample();

    const getActiveContextSummary = (): AssistantContextData => {
        const path = location.pathname;
        if (path.includes('/fracas')) {
            const open = incidents.filter(i => i.status !== 'Closed');
            return {
                type: 'FRACAS Data',
                summary: `Found ${open.length} active incidents. Critical: ${open.filter(i => i.severity === 'Critical').length}.`,
                details: open.slice(0, 3).map(i => `• ${i.fracasNumber}: ${i.title}`).join('\n')
            };
        }
        if (path.includes('/8d')) {
            const open = reports.filter(r => r.status !== 'Closed');
            return {
                type: '8D Reports',
                summary: `Found ${open.length} active 8D reports.`,
                details: open.slice(0, 3).map(r => `• ${r.eightDNumber}: ${r.title}`).join('\n')
            };
        }
        if (path.includes('/lab')) {
            const active = samples.filter(s => s.status !== 'complete');
            return {
                type: 'Lab Samples',
                summary: `Found ${active.length} active samples.`,
                details: active.slice(0, 3).map(s => `• ${s.sampleNumber} (${s.priority})`).join('\n')
            };
        }
        return {
            type: 'System Overview',
            summary: 'Accessing global reliability metrics:',
            details: `• FRACAS Incidents: ${incidents.length}\n• 8D Reports: ${reports.length}\n• Lab Samples: ${samples.length}`
        };
    };

    return { getActiveContextSummary };
};
